import { render, staticRenderFns } from "./ViewReviewModal.vue?vue&type=template&id=59916d64&scoped=true"
import script from "./ViewReviewModal.vue?vue&type=script&lang=js"
export * from "./ViewReviewModal.vue?vue&type=script&lang=js"
import style0 from "./ViewReviewModal.vue?vue&type=style&index=0&id=59916d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59916d64",
  null
  
)

export default component.exports